import { http } from ".";
import { ListParams, ListResp, Resp } from "../types/api";
import { Task, TaskStatus } from "../types/task";

export const getTasks = (params: ListParams = {}): ListResp<Task> => http.get("/api/user/tasks", {
  params,
});

export const getTask = (id: number): Resp<Task> => http.get(`/api/user/task/${id}`);

export const updateTaskStatus = (id: number, status: TaskStatus): Resp<Task> =>
  http.post(`/api/user/task/${id}/chg`, { status });
